/**
 * Unlike granularAxiosInstance, this axiosInstance is completely stateless.
 * This more closely mimics the axiosInstance the catalog uses,
 * making a migration simpler and more straightforward.
 */

import axios from "axios";

export const computeAuthHeader = (authToken: string) => {
  return { Authorization: `Bearer ${authToken}` };
};

export const computeUserHeader = (userId: string) => {
  return { "x-granular-id": userId };
};

export const computeOperationHeader = (operationId: string) => {
  return { "x-operation": operationId };
};

export const computeLocaleHeader = (locale: string) => {
  return { "x-granular-locale": locale };
};

export const computeHeaders = ({
  authToken,
  userId,
  operationId,
  locale,
}: {
  authToken?: string;
  userId?: string;
  operationId?: string;
  locale?: string;
}) => {
  const authHeader = authToken ? computeAuthHeader(authToken) : {};
  const userHeader = userId ? computeUserHeader(userId) : {};
  const operationHeader = operationId
    ? computeOperationHeader(operationId)
    : {};
  const localeHeader = locale ? computeLocaleHeader(locale) : {};
  return {
    ...authHeader,
    ...userHeader,
    ...operationHeader,
    ...localeHeader,
  };
};

export const axiosInstance = axios.create();
